import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, UncontrolledTooltip, UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';
import { getCookie } from '../jwt/_helpers/cookie';
import BootstrapTable from "react-bootstrap-table-next";
import axios from 'axios';
import LoaderInner from './LoaderInner';
import { useTranslation } from 'react-i18next';
import './preScan.css';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const PreScan = ({
  id,
  name,
  pre_scan_status,
  pre_scan_done,
  pre_scan,
  release_pre_scan_declaration,
  status,
  action,
}) => {
    const { t } = useTranslation();
    const tokenAPI = getCookie("token");
    const { setPreScanSuccess, setPreScanError, setPreScanDeclarationSignSuccess, setPreScanDeclarationSignError, forceUpdate, setForceUpdate } = action;

    const [modal, setModal] = useState(false);
    const [performScanModal, setPerformScanModal] = useState(false);
    const [scanInProgress, setScanInProgress] = useState(false);

    const [submissionInProgress, setSubmissionInProgress] = useState(false);
    const [declaration, setDeclaration] = useState(1);
    const [declarationSubmitted, setDeclarationSubmitted] = useState(false);

    const [iconColor, setIconColor] = useState('gray');
    const [messageColor, setMessageColor] = useState('warning');
    const [statusNoteText, setStatusNoteText] = useState('');

    const scanButtonEnabled = (pre_scan_done && declarationSubmitted) ? true : (status === "ready");

    const hasPreScanResults = pre_scan_done && pre_scan.alert && pre_scan.scanned_tracks;
    const scanCompleted = pre_scan && pre_scan.status === "completed";

    const showStatusNote = hasPreScanResults && declarationSubmitted;

    useEffect(() => {
        if(scanButtonEnabled && !pre_scan_done) {
            setIconColor('#ff0b4a');
            setMessageColor('danger');
        }
        else if (pre_scan_done && !declarationSubmitted) {
            setIconColor("var(--branding-theme-color, var(--theme-color, #2fbaad))");
        }
        else if (declarationSubmitted && release_pre_scan_declaration) {
            if (pre_scan && pre_scan.admin_declaration === 1) {
                setIconColor('#ff0b4a');
                setMessageColor('danger');
                setStatusNoteText(t("preScan.form.message.releaseDistributionCancelled"));
            } else {
                if (release_pre_scan_declaration.status === "approved") {
                    setIconColor('green');
                    setMessageColor('success');
                    setStatusNoteText(t(`preScan.form.message.admin_approved`));
                }
                if (release_pre_scan_declaration.status === "rejected") {
                    setIconColor('#ff0b4a');
                    setMessageColor('danger');
                    setStatusNoteText(t(`preScan.form.message.admin_rejected`));
                }
                if (release_pre_scan_declaration.status === "pending") {
                    setIconColor('#f0c231');
                    setMessageColor('warning');
                    setStatusNoteText(t(`preScan.form.message.admin_pending`));
                }
            }
        }
      }, [pre_scan, pre_scan_done, release_pre_scan_declaration, declarationSubmitted]);

    useEffect(() => {
        if(pre_scan && pre_scan.admin_declaration) {
            setDeclaration(pre_scan.admin_declaration);
            setDeclarationSubmitted(true);
        }
    }, [pre_scan]);

    const submitDeclaration = async () => {
        setSubmissionInProgress(true);
        try {
            const response = await axios.post(
                `${API_URL}release-acr-deep-scan/`,
                {
                    id: pre_scan.id,
                    admin_declaration: declaration,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${tokenAPI}`,
                        "x-api-key": X_API_KEY,
                        "Content-Type": "application/json",
                    },
                }
            );
    
            if (response.status === 200) {
                setDeclarationSubmitted(true);
                setPreScanDeclarationSignSuccess(true);
                toggleModal();
                setTimeout(() => {
                setForceUpdate(forceUpdate + 1);
                }, (1000));
            } else {
                setPreScanDeclarationSignError(true);
                console.log("Error occurred while submitting admin pre scan declaration");
            }

        } catch (error) {
            setPreScanDeclarationSignError(true);
            console.log("Error occurred while submitting admin pre scan declaration, Error: ", error);
        } finally {
            setSubmissionInProgress(false);
        }
    };

    const performScan = async () => {
        try {
            setScanInProgress(true);
            let payload = {
                release_id: id,
            };
            const response = await axios.post(`${API_URL}releases/perform-pre-scan/`, payload, {
                headers: {
                    "Authorization": `Bearer ${tokenAPI}`,
                    "x-api-key": X_API_KEY,
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                setPreScanSuccess(true);
                setForceUpdate(forceUpdate + 1);
                setScanInProgress(false);
            } else {
                setPreScanError(true);
                setScanInProgress(false);
            }
            setTimeout(() => {
                togglePerformScanModal();
            }, 1000);
        } catch (error) {
            console.log("Error occurred while performing scan", error);
            setPreScanError(true);
            setScanInProgress(false);
            togglePerformScanModal();
        }
    }

    const toggleModal = () => setModal(!modal);
    const togglePerformScanModal = () => setPerformScanModal(!performScanModal);

    return (
        <div>
        {
            showStatusNote ? (
                <>
                <i 
                    className={"fas fa-bell fa-2x pre-scan-icon" + (showStatusNote ? " pre-scan-avl-icon" : "")}
                    id={`row-pre-scan-note-${id.toString()}`} 
                    aria-hidden="true" 
                    disabled={!showStatusNote}
                    style={{ color: iconColor }}
                ></i>
                <UncontrolledPopover trigger="legacy" id="qc-popover" placement="bottom" target={`row-pre-scan-note-${id.toString()}`} disabled={!showStatusNote}>
                <PopoverBody style={{ padding: "0px" }}>
                    <Alert 
                        color={messageColor}
                        style={{ fontSize: "14px", fontWeight: "bolder", margin: "0px", cursor: "pointer" }}
                        fade={true} 
                        isOpen={showStatusNote}
                    >
                        <b>{statusNoteText}</b>
                    </Alert>
                </PopoverBody>
                </UncontrolledPopover>
                </>
            ) : (
                pre_scan_done ? (
                    <>
                        <i 
                            className="fas fa-eye fa-2x pre-scan-icon pre-scan-avl-icon"
                            id={`row-scan-result-${id}`}
                        aria-hidden="true"
                        style={{ color: iconColor, cursor: "pointer" }}
                        onClick={scanCompleted ? toggleModal : undefined}
                    ></i>
                    {
                        !scanCompleted && (
                            <UncontrolledTooltip
                                placement="top"
                                trigger="hover"
                                target={`row-scan-result-${id}`}
                            >
                                {t("preScan.form.message.scanInProgress")}
                            </UncontrolledTooltip>
                        )
                    }
                </>
            ) : (
            <>
                <i
                    className="fas fa-search fa-2x pre-scan-icon"
                    id={"row-pre-scan-" + id.toString()} 
                    aria-hidden="true" 
                    style={{ color: iconColor, cursor: "pointer" }}
                    disabled={!scanButtonEnabled}
                    onClick={scanButtonEnabled ? togglePerformScanModal : undefined}
                ></i>
                {
                    !scanButtonEnabled && (
                        <UncontrolledTooltip
                            placement="top"
                            trigger="hover"
                            target={`row-pre-scan-${id.toString()}`}
                            >
                                {t("preScan.form.message.releaseMustBeReady")}
                        </UncontrolledTooltip>
                    )
                }
               </>
            )
        )}

        <Modal isOpen={modal} toggle={toggleModal} className="modal-lg">
            <ModalHeader toggle={toggleModal}>{t("preScan.form.modal.preScanResults.header")}</ModalHeader>
            <ModalBody>
                {hasPreScanResults ? (
                    <>
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <div className="mb-3">
                                {t("preScan.form.modal.preScanResults.body.description")}
                            </div>
                            <h5>{t("preScan.form.modal.preScanResults.body.label.flaggedTracks")}</h5>
                            <BootstrapTable
                                keyField="id"
                                data={pre_scan.scanned_tracks.flatMap((track) =>
                                track.alert ? [
                                    ...track.music_results.map((musicResult, index) => ({
                                        id: `${track.id}-music-${index}`,
                                        track_name: track.track_name,
                                        type: t("preScan.form.modal.preScanResults.body.label.music"),
                                        title: musicResult.result.title,
                                        artists: musicResult.result.artists.map(artist => artist.name).join(', '),
                                        album: musicResult.result.album.name,
                                        label: musicResult.result.label,
                                        release_date: musicResult.result.release_date,
                                        score: musicResult.score
                                    })),
                                    ...track.cover_results.map((coverSongResult, index) => ({
                                        id: `${track.id}-cover-${index}`,
                                        track_name: track.track_name,
                                        type: t("preScan.form.modal.preScanResults.body.label.cover"),
                                        title: coverSongResult.result.title,
                                        artists: coverSongResult.result.artists.map(artist => artist.name).join(', '),
                                        album: coverSongResult.result.album.name,
                                        label: coverSongResult.result.label,
                                        release_date: coverSongResult.result.release_date,
                                        score: coverSongResult.score
                                    }))
                                ] : []
                                )}
                                columns={[
                                {
                                    dataField: "track_name",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.trackName")
                                },
                                {
                                    dataField: "type",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.type")
                                },
                                {
                                    dataField: "title",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.title")
                                },
                                {
                                    dataField: "artists",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.artists")
                                },
                                {
                                    dataField: "album",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.album")
                                },
                                {
                                    dataField: "label",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.label")
                                },
                                {
                                    dataField: "release_date",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.releaseDate")
                                },
                                {
                                    dataField: "score",
                                    text: t("preScan.form.modal.preScanResults.body.table.column.score")
                                }
                                ]}
                                bordered={false}
                            />
                        </div>
                
                        <div className="mt-4 mb-4">
                            {t("preScan.form.modal.preScanResults.body.label.signDeclaration")}
                            <br /><br />
                            <FormGroup check className="">
                                <Label check>
                                    <Input type="radio" id="cancel" name="declaration_cancel" value={1} onChange={() => {setDeclaration(1)}} checked={declaration===1} disabled={declarationSubmitted} />
                                    <span className="ml-2">{t("preScan.form.modal.preScanResults.body.label.cancelRelease")}</span>
                                </Label>
                            </FormGroup>
                            <FormGroup check className="mt-3">
                                <Label check>
                                    <Input type="radio" id="approve" name="declaration_approve" value={2} onChange={() => {setDeclaration(2)}} checked={declaration===2} disabled={declarationSubmitted} />
                                    <span className="ml-2">
                                        {t("preScan.form.modal.preScanResults.body.label.approveRelease.point1")}<br/>
                                        {t("preScan.form.modal.preScanResults.body.label.approveRelease.point2")}<br/>
                                        {t("preScan.form.modal.preScanResults.body.label.approveRelease.point3")}<br/>
                                        {t("preScan.form.modal.preScanResults.body.label.approveRelease.point4")}<br/>
                                        {t("preScan.form.modal.preScanResults.body.label.approveRelease.point5")}<br/>
                                    </span>
                                </Label>
                            </FormGroup>
                        </div>
                    </>
                ): (
                    <div>
                        {t("preScan.form.modal.preScanResults.body.label.noFlaggedTracks")}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {
                    hasPreScanResults && (
                    <Button color="success" onClick={submitDeclaration} disabled={submissionInProgress ||  declarationSubmitted}>{t("preScan.form.modal.preScanResults.button.submit")}</Button>
                )}
                <Button color="secondary" onClick={toggleModal}>{t("preScan.form.modal.preScanResults.button.close")}</Button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={performScanModal} toggle={togglePerformScanModal}>
            <ModalHeader toggle={togglePerformScanModal}>{t("preScan.form.modal.performScan.header")}</ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    {t("preScan.form.modal.performScan.body")}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={togglePerformScanModal} disabled={scanInProgress}>{t("preScan.form.modal.performScan.button.cancel")}</Button>
                <Button color="success" onClick={performScan} disabled={scanInProgress}>{t("preScan.form.modal.performScan.button.performScan")}</Button>
            </ModalFooter>
        </Modal>
        <LoaderInner show={scanInProgress} />
        </div>
    );
};

export default PreScan;